<template>
    <van-skeleton title :row="3"  :loading="skeLoading" style="margin-top: 20px">
        <div>
            <van-row class="dk-title" type="flex" align="center">
                <img src="@/assets/temperature_randis.png" alt="">
                <span style="font-weight: bold">客户信息</span>
            </van-row>
            <van-grid :column-num="2">
                <van-grid-item text="客户名称：" />
                <van-grid-item :text="model.customerName"/>
            </van-grid>

            <van-row class="dk-title" type="flex" align="center">
                <img src="@/assets/temperature_randis.png" alt="">
                <span style="font-weight: bold">{{model.orderType == 0 ? '发货': model.orderType == 1 ? '加购': model.orderType == 2 ? '结算':''}}信息</span>
            </van-row>
            <van-grid :column-num="2" :center="false" v-if="model.orderType == 0">
                <van-grid-item>
                    <template slot="text">
                        <span class="dk-text dk-text-center">
                            {{model.recipient}}
                            <br />
                            {{model.phone}}
                        </span>
                    </template>
                </van-grid-item>
                <van-grid-item :text="model.province + model.city + model.district + model.address"/>
            </van-grid>
            <van-grid :column-num="2" :center="false" v-if="model.orderType == 0" v-for="(logisticsCompany, index) in model.storeLogisticsRecordList" :key="'arriveNo'+index">
                <van-grid-item>
                    <template slot="text">
                        <span class="dk-text">
                            <van-badge dot :color="!logisticsCompany.state ? '#faad14' : logisticsCompany.state == 0 ? '#52c41a': logisticsCompany.state == 1 ? '#f5222d' : '#d9d9d9'"></van-badge>
                            {{logisticsCompany.kdName}}
                            <a @click="handleDetail(index)" style="color: #1890FF">{{logisticsCompany.nu}}</a>
                        </span>
                    </template>
                </van-grid-item>
                <van-grid-item>
                    <template slot="text">
                        <template v-if="logisticsCompany.storeCustomerShippingCategory">
                            <span class="dk-text" v-for="(shippingCategory, recordIndex) in logisticsCompany.storeCustomerShippingCategory.categoryNumberList" :key="'ssdd'+recordIndex">
                                {{shippingCategory.name}}
                                {{shippingCategory.packageNumber}}{{shippingCategory.numberUnit}}
                                ({{shippingCategory.value}}{{shippingCategory.priceUnit}})
                                <template v-if="recordIndex < (logisticsCompany.storeCustomerShippingCategory.categoryNumberList.length -1)">
                                    <br />
                                </template>
                            </span>
                        </template>
                    </template>
                </van-grid-item>
            </van-grid>
            <van-grid :column-num="3" v-for="(item,index) in model.categoryNumberList" :key="'cata_'+index">
                <van-grid-item>
                    <span slot="text" class="dk-text dk-text-center">
                        {{item.name}}
                        <br />
                        <span>
                            ({{item.number+item.priceUnit+'/'+item.numberUnit}})
                        </span>
                    </span>
                </van-grid-item>
                <van-grid-item :text="item.numberPackage || item.numberPackage == 0 ? String(item.numberPackage) + item.numberUnit : '--'"/>
                <van-grid-item :text="item.value || item.value == 0 ? String(item.value) + item.priceUnit : '--'" />
            </van-grid>

            <van-row class="dk-title" type="flex" align="center">
                <img src="@/assets/temperature_randis.png" alt="">
                <span style="font-weight: bold">实时库存</span>
            </van-row>
            <van-grid :column-num="3" v-for="(item,index) in model.listCustomerLeft" :key="'left_'+index">
                <van-grid-item>
                    <span slot="text" :class="item.isWarn ? 'dk-text-warn':'dk-text'" class="dk-text-center">
                        {{item.name}}
                        <br />
                        <span>
                            ({{item.number+item.priceUnit+'/'+item.numberUnit}})
                        </span>
                    </span>
                </van-grid-item>
                <van-grid-item>
                    <span slot="text" :class="item.isWarn ? 'dk-text-warn':'dk-text'">
                        {{item.packageNumber || item.packageNumber == 0 ? String(item.packageNumber) + item.numberUnit : '--'}}
                    </span>
                </van-grid-item>
                <van-grid-item>
                    <span slot="text" :class="item.isWarn ? 'dk-text-warn':'dk-text'">
                        {{item.value || item.value == 0 ? String(item.value) + item.priceUnit : '--'}}
                    </span>
                </van-grid-item>
            </van-grid>

            <van-row class="dk-title" type="flex" align="center">
                <img src="@/assets/temperature_randis.png" alt="">
                <span style="font-weight: bold">已绑定推送</span>
            </van-row>
            <van-grid :column-num="3" v-for="(item,index) in model.customerDetailList" :key="'detail_'+index">
                <van-grid-item :text="item.contact" />
                <van-grid-item :text="item.phone"/>
                <van-grid-item>
                    <van-checkbox-group v-if="item.notificationChannel" v-model="item.notificationChannel" direction="horizontal" icon-size="12px" style="font-size: 13px">
                        <van-checkbox name="1" shape="square">短信</van-checkbox>
                        <van-checkbox name="2" shape="square">微信</van-checkbox>
                    </van-checkbox-group>
                </van-grid-item>
            </van-grid>

            <!--弹出框-->
            <van-dialog
                    v-model="showRecord"
                    title="物流信息"
                    show-cancel-button
                    :show-confirm-button="showConfirm"
                    cancel-button-text="关闭"
                    theme="round-button"
                    @cancel="closeRecord">
                <!--物流状态-->
                <van-row class="dk-record-title-state">
                    <van-badge dot color="#52c41a"></van-badge><span @click="changeState('0')">在途</span>
                    <van-badge dot color="#d9d9d9" style="margin-left: 8px"></van-badge><span @click="changeState('2')">签收</span>
                    <van-badge dot color="#faad14" style="margin-left: 8px"></van-badge><span @click="changeState()">未揽收</span>
                    <van-badge dot color="#f5222d" style="margin-left: 8px"></van-badge><span @click="changeState('1')">异常</span>
                </van-row>
                <van-row class="dk-record-title">
                    <span>
                        <van-badge dot :color="!logisticsCompanyRecord.state ? '#faad14' : logisticsCompanyRecord.state == 0 ? '#52c41a': logisticsCompanyRecord.state == 1 ? '#f5222d' : '#d9d9d9'"></van-badge>
                        {{logisticsCompanyRecord.kdName}}
                        {{logisticsCompanyRecord.nu}}
                    </span>
                </van-row>
                <!--产品信息-->
                <template v-if="logisticsCompanyRecord.storeCustomerShippingCategory">
                    <van-row class="dk-record-title-product">
                        <span v-for="(shippingCategory, recordIndex) in logisticsCompanyRecord.storeCustomerShippingCategory.categoryNumberList" :key="'ssdd'+recordIndex">
                            {{shippingCategory.name}}
                            {{shippingCategory.packageNumber}}{{shippingCategory.numberUnit}}
                            ({{shippingCategory.value}}{{shippingCategory.priceUnit}})
                            <template v-if="recordIndex < (logisticsCompanyRecord.storeCustomerShippingCategory.categoryNumberList.length -1)">
                                <br />
                            </template>
                        </span>
                    </van-row>
                </template>
                <!--物流记录-->
                <van-steps direction="vertical" :active="0" class="dk-record" v-if="logisticsRecord">
                    <van-step v-for="(item,index) in logisticsRecord.recordList" :key="'re'+index">
                        <van-tag slot="active-icon" round color="#f50" class="receipt" v-if="logisticsRecord.isCheck == 1 && index == 0">收</van-tag>
                        <p>{{item.status}}</p>
                        <p>{{item.time}}</p>
                        <p>{{item.context}}</p>
                    </van-step>
                </van-steps>
                <span v-else class="dk-record-text">暂无物流信息</span>
            </van-dialog>
        </div>
    </van-skeleton>
</template>

<script>
    import {Button, Col, Row, Calendar, Cell, CellGroup, Popup, Area, Field, Picker, Grid, GridItem,Divider,Checkbox, CheckboxGroup, Badge, Dialog, Step, Steps, Icon, Tag, Toast, Skeleton} from 'vant';
    import {getAction, postAction} from '@/api/manage'
    import {getStoreShipping, getStoreRecord,changeState} from '@/api/index'

    export default {
        name: "store",
        components: {
            [Button.name]: Button,
            [Col.name]: Col,
            [Row.name]: Row,
            [Calendar.name]: Calendar,
            [Cell.name]: Cell,
            [CellGroup.name]: CellGroup,
            [Area.name]: Area,
            [Popup.name]: Popup,
            [Field.name]: Field,
            [Picker.name]: Picker,
            [Grid.name]: Grid,
            [GridItem.name]: GridItem,
            [Divider.name]: Divider,
            [Checkbox.name]: Checkbox,
            [CheckboxGroup.name]: CheckboxGroup,
            [Badge.name]: Badge,
            [Dialog.Component.name]: Dialog.Component,
            [Step.name]: Step,
            [Steps.name]: Steps,
            [Icon.name]: Icon,
            [Tag.name]: Tag,
            [Skeleton.name]: Skeleton,
        },
        data() {
            return {
                skeLoading: true,
                model:{},
                id: '',
                showRecord: false,
                showConfirm: false,
                logisticsCompanyRecord: {},
                logisticsRecord: {},
            }
        },
        created() {
            this.id = this.$route.query.id;
            if(this.id){
                this.getStoreShipping(this.id);
            }
        },
        methods: {
            getStoreShipping(id){
                getAction(getStoreShipping, {id: id}).then(res => {
                    if (res.success) {
                        if(res.result){
                            this.model = res.result;
                            this.skeLoading = false;
                        }else{
                            Toast('暂无数据');
                        }
                    }else{
                        Toast('暂无数据');
                    }
                })
            },
            handleDetail(index){
                this.logisticsCompanyRecord = this.model.storeLogisticsRecordList[index];
                this.logisticsRecord = {};
                this.getStoreRecord(this.logisticsCompanyRecord.nu);
            },
            getStoreRecord(arriveNo){
                getAction(getStoreRecord, {shippingId: this.id, nu: arriveNo}).then(res => {
                    if (res.success) {
                        this.logisticsRecord = res.result;
                        this.showRecord = true;
                    } else {
                        Toast('暂无数据');
                    }
                })
            },
            closeRecord(){
                this.showRecord = false;
            },
            //修改物流灯状态
            changeState(state){
                if(!this.logisticsRecord){
                    return;
                }
                Dialog.confirm({
                    title: '修改状态',
                    message: '是否修改物流状态为：' + (!state ? '未揽收': state == 0 ? '在途': state == 1 ? '异常':'签收'),
                })
                    .then(() => {
                        // on confirm
                        let formData = {};
                        formData.id = this.logisticsRecord.id;
                        formData.state = state == 2 ? '3': state == 1 ? '2': state;
                        formData.isManual = 1;
                        postAction(changeState, formData).then(res => {
                            if (res.success) {
                                Toast(res.message);
                                this.logisticsCompanyRecord.state = state;
                            } else {
                                Toast(res.message);
                            }
                        }).catch(() => {
                            console.log("修改物流灯异常");
                        })
                    })
                    .catch(() => {
                        // on cancel
                    });
            },
        }
    }
</script>

<style scoped>
    p{
        margin: 0.4em 0;
        font-size: 14px;
    }
    /deep/ .van-badge--dot{
        width: 10px;
        height: 10px;
    }
    /deep/ .van-dialog__header {
        padding-top: 0.4rem;
    }
    /deep/ .van-grid-item__content {
        display: -webkit-box;
        display: -webkit-flex;
        display: flex;
        -webkit-box-orient: vertical;
        -webkit-box-direction: normal;
        -webkit-flex-direction: column;
        flex-direction: column;
        box-sizing: border-box;
        height: 100%;
        padding: 0.32667rem 0.21333rem;
        background-color: #fff;
    }
    .dk-title {
        height: 49px;
        font-size: 16px;
        color: #333;
        background: #EEEEEE;
        padding: 0 15px;
    }

    .dk-title img {
        width: 4px;
        height: 16px;
        margin-right: 10px;
    }
    .dk-text {
        color: #646566;
        font-size: 0.32rem;
        line-height: 1.5;
        word-wrap: break-word;
    }
    .dk-text-warn{
        color: #D9001B;
        font-size: 0.32rem;
        line-height: 1.5;
        word-wrap: break-word;
    }
    .dk-text-center{
        text-align: center;
    }
    .dk-record{
        height: 400px;
        overflow-y: auto;
    }
    .dk-record-title {
        display: flex;
        align-items: center;
        height: 28px;
        font-size: 14px;
        color: rgba(0, 0, 0, 0.85);
        padding: 0 0 0 0.85333em;
    }
    .dk-record-title-product {
        font-size: 0.28rem;
        color: rgba(0, 0, 0, 0.65);
        padding: 0 0 0 2.35333em;
    }
    .dk-record-title-state {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 28px;
        font-size: 12px;
        color: rgba(0, 0, 0, 0.85);
        padding: 0 0 0 0.85333em;
    }
    .dk-record-text {
        display: flex;
        align-items: center;
        height: 60px;
        font-size: 14px;
        color: #646566;
        padding: 0 0 0 1.85333em;
    }
</style>
